var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3678 14.0138L17.776 16.3818C18.445 17.0397 17.4417 18.0268 16.7727 17.3689L14.3643 15.0007C11.4713 17.3476 7.20329 17.1683 4.52149 14.5305C1.6582 11.7143 1.6582 7.14819 4.52149 4.33193C7.38477 1.51566 12.0271 1.51566 14.8904 4.33193C17.5724 6.96995 17.7545 11.1683 15.3678 14.0138ZM13.887 5.31888C11.5779 3.0477 7.83409 3.0477 5.52499 5.31888C3.21589 7.59007 3.21589 11.2724 5.52499 13.5436C7.83409 15.8147 11.5779 15.8147 13.887 13.5436C16.1961 11.2724 16.1961 7.59007 13.887 5.31888Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9829418c5bdd84f867e7ae7b22e6e31c.svg";
export { ForwardRef as ReactComponent };